"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = notify;

var _pubsubJs = _interopRequireDefault(require("pubsub-js"));

var _lodash = _interopRequireDefault(require("lodash.isundefined"));

var events = _interopRequireWildcard(require("./constants/events"));

var _toast = _interopRequireDefault(require("./toast"));

var _config = require("./config");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * @param {Object} options
 * @param {Node|String} options.content
 * @param {Array} options.actions
 * @param {Boolean} options.hideCloseControl
 * @param {String} options.type
 * @param {Number} options.duration
 * @returns {Toast}
 */
function notify(_ref) {
  var content = _ref.content,
      _ref$actions = _ref.actions,
      actions = _ref$actions === void 0 ? [] : _ref$actions,
      hideCloseControl = _ref.hideCloseControl,
      type = _ref.type,
      duration = _ref.duration;

  var _getConfig = (0, _config.getConfig)(),
      defaultDuration = _getConfig.duration,
      size = _getConfig.size;

  var toast = new _toast["default"](content, actions, hideCloseControl, type, (0, _lodash["default"])(duration) ? defaultDuration : duration, size);

  _pubsubJs["default"].publish(events.ADD_TOAST, toast);

  return toast;
}